import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "box-container" }
const _hoisted_2 = { class: "box-font" }


import router from "@/router";


export default /*@__PURE__*/_defineComponent({
  __name: 'FunctionBox',
  props: {
  // 文字
  text: String,
  // icon
  icon: String,
},
  setup(__props) {

const handleClick = () => {
  router.push("/services").then(() => {
    // 定位到顶部
    window.scrollTo(0, 0);
  });
};

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("i", {
      class: _normalizeClass(props.icon),
      style: {"font-size":"50px","color":"#fff"}
    }, null, 2),
    _createElementVNode("div", _hoisted_2, _toDisplayString(props.text), 1),
    _createElementVNode("div", {
      class: "customer-button",
      onClick: handleClick
    }, "→")
  ]))
}
}

})